// Wrap tables without classes in responsive containers with accessibility attributes
// Based on: http://adrianroselli.com/2017/11/a-responsive-accessible-table.html#Responsive

const createResponsiveWrapper = (tableId: string): HTMLDivElement => {
  const wrapper = document.createElement('div');
  wrapper.setAttribute('role', 'region');
  wrapper.setAttribute('aria-labelledBy', tableId);
  wrapper.setAttribute('tabindex', '0');
  wrapper.className = 'table-responsive';
  return wrapper;
};

const setCaptionId = (table: HTMLTableElement, tableId: string): void => {
  const caption = table.querySelector<HTMLTableCaptionElement>('caption');
  if (caption) {
    caption.id = tableId;
  }
};

const wrapTableInResponsiveContainer = (table: HTMLTableElement, index: number): void => {
  const tableId = `responsive-table-${index}`;
  
  setCaptionId(table, tableId);
  
  const wrapper = createResponsiveWrapper(tableId);
  
  table.parentNode?.insertBefore(wrapper, table);
  wrapper.appendChild(table);
};

const init = (): void => {
  const tablesWithoutClasses = document.querySelectorAll<HTMLTableElement>('table:not([class])');
  tablesWithoutClasses.forEach(wrapTableInResponsiveContainer);
};

export { init };
